module.exports = __webpack_public_path__ + "static/img/manual_zh_21.2ff9cfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_21.png
// module id = AveW
// module chunks = 4